module.exports = __webpack_public_path__ + "static/media/barber-joke.721954ed.PNG";